export enum CodeDemo {
  Demo = 100000,
}

// 所有后端返回的code码
export const BackEndCode = {
  ...CodeDemo,
};
